import { Comment } from "../../models";

export interface CommentListResult {
  comments: Comment[];
  commentCount: { total: number; currentPage: number };
  pages: { total: number; currentPage: number };
}
